import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map, Observable } from 'rxjs';
import Constants from 'src/app/core/constants/constants';
import { ILoaDetails } from 'src/app/core/models/interface';
import { RestAPIsService } from 'src/app/core/services/rest-apis.service';
import { SessionService } from 'src/app/core/services/session.service';
import * as moment from 'moment';
import { UserService } from 'src/app/core/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { IContact, IContactDetails } from 'src/app/core/models/contactDetails.interface';
import { UIMessagesService } from 'src/app/core/services/uimessages.service';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-add-loa',
  templateUrl: './add-loa.component.html',
  styleUrls: ['./add-loa.component.scss']
})
export class AddLoaComponent implements OnInit {
  @Output() requireReloadSite = new EventEmitter();
  successMessage = '';
  errorMessage = '';
  loaMessageTitle = 'Generate LoA';
  loaMessageBody = 'To generate recommendations, we need access to your energy details. Please select below option to create the necessary Letter of Authority (LoA).'
  loaForm: FormGroup;
  isLoaLoading = false
  loaList: ILoaDetails[] = [];
  fileError = ''
  selectedFile: File | null = null;
  LOAFileConfig = Constants.LOAFileConfig;
  isLoading = false
  isContactLoading = false
  reloadLOA = false
  companySiteData:any ={};
  currentSiteId!:string
  siteData = {}
  fetchDetailsOnly = false
  contactList: IContactDetails[] = []
  listOfTitles: string[] = [
    'Mr',
    'Mrs',
    'Ms',
  ];
  contactDetailFormGroup: FormGroup;
  currentSiteData: any = {};
  selectedLoa:any;

  constructor(private restAPI: RestAPIsService, private modalService: NgbModal,
    private sessionService: SessionService, public userService: UserService,
    private toaster: ToastrService, private spinner: NgxSpinnerService,
    private uiMessagesService: UIMessagesService, private utilService: UtilService
  ) {
    this.loaForm = new FormGroup({
      generateType: new FormControl(),
      loaId: new FormControl(),
      startDate: new FormControl(),
      endDate: new FormControl(),
      expiry: new FormControl(),
      contactEmail: new FormControl({disabled: true, value: null}),
    })
    this.contactDetailFormGroup = new FormGroup({
      title: new FormControl(null, [Validators.required]),
      firstName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.pattern(Constants.Regex.firstName)]),
      lastName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.pattern(Constants.Regex.lastName)]),
      phone: new FormControl('', [Validators.required, Validators.maxLength(11), Validators.pattern(Constants.Regex.Mobile)]),
      contactEmail: new FormControl('', [Validators.required, Validators.pattern(Constants.Regex.Email)]),
      contactSource: new FormControl('USER_PROVIDED'),
    });
  }

  ngOnInit(): void {  
    this.companySiteData = this.sessionService.getItemFromSession(Constants.sessionConstants.COMPANY_SITE_DATA);  
    const loaPopupData = this.uiMessagesService.getPopupUIMessageByKey(Constants.POPUP_TYPES.LOA)
    this.loaMessageTitle = loaPopupData?.TITLE || this.loaMessageTitle;
    this.loaMessageBody = loaPopupData?.MESSAGE || this.loaMessageBody;
    this.fetchLOAList()
    this.loaForm.get('generateType')?.valueChanges.subscribe(data=>{
      this.selectedFile = null
      this.updateFormValidation(data)
    })
    this.loaForm.get('contactEmail')?.valueChanges.subscribe(data=>{
      if(data == 'addNewContact'){
        // this.manualContact = true;
      }
      else{
        // this.manualContact = false;
      }
    })
    this.getAllContacts();
    if(this.companySiteData.contactEmail){
      this.loaForm.patchValue({contactEmail: this.companySiteData.contactEmail})
    }
  }

  get f1(): { [key: string]: AbstractControl } {
    return this.loaForm.controls
  }

  enableContactEdit(): void{
    if(this.loaForm.get('contactEmail')?.disabled){
      this.loaForm.get('contactEmail')?.enable();
      const contact = this.contactList.find(el => el.email == this.companySiteData.contactEmail)
      if(contact){
        this.contactDetailFormGroup.patchValue({
          title: contact.title,
          firstName: contact.firstName,
          lastName: contact.lastName,
          phone: contact.phone,
          contactEmail: contact.email,
        })
      }
    }
    else{
      this.loaForm.get('contactEmail')?.disable()
    }
  }

  updateFormValidation(data: number): void{
    this.errorMessage = '';
    this.successMessage = ''
    if(data == 1){
      this.loaForm.get('loaId')?.addValidators([Validators.required])
      this.loaForm.get('expiry')?.clearValidators()
      this.loaForm.get('loaId')?.updateValueAndValidity()
      this.loaForm.get('expiry')?.updateValueAndValidity()
    }
    else if(data == 2){
      this.loaForm.get('loaId')?.clearValidators()
      this.loaForm.get('expiry')?.clearValidators()
      this.loaForm.get('loaId')?.updateValueAndValidity()
      this.loaForm.get('expiry')?.updateValueAndValidity()
    }
    else if(data == 3){
      this.loaForm.get('expiry')?.addValidators([Validators.required])
      this.loaForm.get('loaId')?.clearValidators()
      this.loaForm.get('loaId')?.updateValueAndValidity()
      this.loaForm.get('expiry')?.updateValueAndValidity()
    }
  }

  createExpiryDate(month: number): void{
    const today = moment(new Date()).format('YYYY-MM-DD')
    const endDate  = moment(new Date()).add(month, 'M').format('YYYY-MM-DD')
    this.loaForm.patchValue({
      startDate:  today,
      endDate: endDate
    })
  }

  getAllContacts(): void{
    this.isContactLoading = true
    const param = new URLSearchParams({
      companyNumber: this.companySiteData.companyNumber,
      customerEmail: this.companySiteData.customerEmail
    }).toString()
    this.restAPI.getAPI(`carbon/v3/get-contact?${param}`, 'domestic').subscribe({
      next: (resp) => {
        if(resp.code == 200){
          if(resp.data?.length){
            this.contactList = [
              {id: 0, title: '', firstName: '+', lastName: 'Add new contact', phone: '', email: 'addNewContact'},
              ...resp.data.filter((el: IContactDetails) => el.email)
            ]
            this.selectContact(this.companySiteData.contactEmail)
          }
          else{
            this.contactList = [{id: 0, title: '', firstName: '+', lastName: 'Add new contact', phone: '', email: 'addNewContact'}]
          }
        }
        this.isContactLoading = false
      },
      error: () => {
        this.contactList = [{id: 0, title: '', firstName: '+', lastName: 'Add new contact', phone: '', email: 'addNewContact'}]
        this.isContactLoading = false
      }
    })
  }

  selectContact(contactEmail: string): void {
    this.contactDetailFormGroup.reset();
    if(contactEmail != 'addNewContact'){
      const contact = this.contactList.find(el => el.email == contactEmail)
      if(contact){      
        // Set the selected contact details to the form
        this.contactDetailFormGroup.patchValue({
          title: contact.title || null,
          firstName: contact?.id !== 0 ? contact.firstName : '',
          lastName: contact.lastName,
          phone: contact.phone,
          contactEmail: contact.email,
          contactSource: contact?.contactSource || 'USER_PROVIDED'
        });
      }
    }
  }

  saveContactInfo(): void {
    if(this.f1['generateType'].value == 1){
      this.doAction();
      return;
    }
    if (this.contactDetailFormGroup.invalid) {
      this.contactDetailFormGroup.markAllAsTouched()
      return;
    }
    const requestPayload = {
      customerEmail: this.companySiteData.customerEmail,
      companyNumber: this.companySiteData.companyNumber,
      ...this.contactDetailFormGroup.getRawValue()
    }
    this.isLoading = true;
    let api:any
    if(this.contactList.find(el => el.email == this.contactDetailFormGroup.getRawValue().contactEmail)){
      const path = 'carbon/v3/update-contact'
      api = this.restAPI.patchAPI(path, requestPayload, 'domestic')
    } 
    else{
      const path = 'carbon/v3/add-contact'
      api = this.restAPI.postAPI(path, requestPayload, 'domestic')
    }
    
    api.subscribe({
      next: (res:any) => {
        if (res.code === 201 || res.code === 200) {
          this.doAction()
        } else {
          this.errorMessage = res.data
          this.isLoading = false;
        }
      },
      error: (err:any) => {
        this.isLoading = false;
        console.log('ERROR:', err);
        if (err?.error?.error?.[0]?.message) {
          this.errorMessage = err.error.error[0].message
        }
        else
          this.errorMessage = 'Internal error, Please try again later.'
      },
    })
  }

  doAction(): void{
    this.successMessage = ''
    this.errorMessage = ''
    let api: Observable<any>;
    let checkpointEvent = 'SELECT_LOA';
    const siteData = this.sessionService.getItemFromSession(Constants.sessionConstants.SELECTED_SITE_DATA);
    if(this.f1['generateType'].value == 1) {
      const payload = new URLSearchParams({
        siteId: this.currentSiteId || this.companySiteData.siteId,
        companyNumber: this.companySiteData.companyNumber,
        loaId: this.loaForm.value.loaId,
        customerEmail: this.companySiteData.customerEmail?.toLocaleLowerCase(),
        loaStatus: this.loaList.find(el => el.loaId == this.loaForm.value.loaId)?.loaStatus || '',
      })
      api = this.restAPI.patchAPI(`carbon/v3/loa/site?${payload}`, {}, 'domestic')
    }
    else if(this.f1['generateType'].value == 2) {
      if(this.userService.isLOAAwaiting){
        checkpointEvent = 'RESEND_LOA';
        const payload = {
          customerEmail: this.companySiteData.customerEmail?.toLocaleLowerCase()
        }
        api = this.restAPI.postAPI(`carbon/v3/loa/${siteData?.loaId}/resend`, payload, 'domestic')
      }
      else{
        checkpointEvent = 'GENERATE_LOA';
        const payload = {
          companyNumber: this.companySiteData.companyNumber,
          contactEmail: this.contactDetailFormGroup.getRawValue().contactEmail?.toLocaleLowerCase(),
          customerEmail: this.companySiteData.customerEmail?.toLocaleLowerCase(),
          siteId: this.currentSiteId || this.companySiteData.siteId,
        }
        api = this.restAPI.postAPI(`carbon/v3/loa`, payload, 'domestic')
      }
    }
    else{
      checkpointEvent = 'LOA_UPLOAD';
      const payload = new FormData();
      payload.append('loaFile', this.selectedFile as any, this.selectedFile?.name);
      const queryParam = new URLSearchParams()
      queryParam.append('customerEmail', this.companySiteData.customerEmail?.toLocaleLowerCase());
      queryParam.append('contactEmail', this.contactDetailFormGroup.getRawValue().contactEmail?.toLocaleLowerCase());
      queryParam.append('companyNumber', this.companySiteData.companyNumber);
      queryParam.append('siteId', this.currentSiteId || this.companySiteData.siteId);
      queryParam.append('startDate', this.loaForm.value.startDate);
      queryParam.append('endDate', this.loaForm.value.endDate);
      
      api = this.restAPI.postAPI(`file/v3/loa/upload?${queryParam.toString()}`, payload, 'domestic', true)
    }
    this.isLoading = true;
    api.subscribe({
      next: (resp) => {
        this.restAPI.addCheckpoint({ event: checkpointEvent });
        if(resp.code == 201 || resp.code == 200){
          if(this.f1['generateType'].value != 2){
            this.utilService.setRecommendationReload(true);
          }
          this.reloadLOA = true;
          this.successMessage = resp.data.message
          this.reloadSiteData()
          this.toaster.success(resp.data.message)
        }
        else{
          this.errorMessage = resp.data.message
        }
        this.isLoading = false;
      },
      error: (error) => {
        if(error.error?.data){
          this.errorMessage = error.error.data
        }
        else{
          this.errorMessage = error.error?.error?.[0]?.message || 'Something went wrong, please try again later'
        }
        this.isLoading = false;
      }
    })
  }

  reloadSiteData(): void{
    if(this.currentSiteId || this.companySiteData.siteId){
      this.spinner.show()
      this.userService.getSiteDetails(this.currentSiteId || this.companySiteData.siteId, !this.fetchDetailsOnly).subscribe({
        next: (resp)=>{
          this.spinner.hide()
          if(resp.code == 200){
            if(this.fetchDetailsOnly){
              this.siteData = resp.data
            }
            this.requireReloadSite.emit(resp.data)
          }
          this.close()
        },
        error: () => {
          this.spinner.hide()
          this.close()
        }
      })
    }
    else{
      this.close()
    }
  }

  close(): void{
    this.modalService.dismissAll();
  }

  fetchLOAList(): void{
    this.spinner.show();
    this.isLoaLoading = true;
    const companyData = {
      customerEmail: this.companySiteData.customerEmail,
      companyNumber: this.companySiteData.companyNumber,
    }
    const payload = new URLSearchParams(companyData)
    const path = `carbon/v3/loa?${payload.toString()}`
    this.restAPI.getAPI(path, 'domestic').subscribe({
      next: (resp) => {
        if(resp.code == 200){
          this.loaList = resp.data
          this.loaForm.patchValue({generateType:1})
          this.loaForm.patchValue({ generateType: 1 })

          if(this.currentSiteData?.loaId && this.loaList.find(el => el.loaId == this.currentSiteData.loaId)){
            this.loaForm.patchValue({loaId: this.currentSiteData.loaId})
          }
          else{
            const siteData = this.sessionService.getItemFromSession(Constants.sessionConstants.SELECTED_SITE_DATA);
            const selectedLoa = this.loaList.find(el => el.loaId == siteData.loaId)
            if(siteData?.loaId && selectedLoa){
              this.loaForm.patchValue({loaId: siteData.loaId})
              this.selectedLoa = selectedLoa
            }
          }
        }
        else{
          this.loaForm.patchValue({generateType:2})
        }
        this.spinner.hide()
        this.isLoaLoading = false;
      },
      error: () => {
        this.spinner.hide();
        this.isLoaLoading = false;
        this.loaForm.patchValue({generateType:2})
      }
    })
  }

  onFileChange(event: Event): void{
    this.fileError = ''
    const element = event.currentTarget as HTMLInputElement;
    if(element.files){
      const file = element.files[0]
      if (file.size > this.LOAFileConfig.MaxSize){
        this.fileError = `Max file size is allowed to ${(this.LOAFileConfig.MaxSize/1024)/1024} MB`;
        return;
      }
      const extension:string = file.name.split('.').pop() ?? ''
      if (!this.LOAFileConfig.FileType.includes(extension.toLocaleLowerCase())){
        this.fileError = 'Please upload your file in PDF format. Other file formats are not supported at this time';
        return;
      }
      this.selectedFile = file
    }
  }

  get isDisableForm(): boolean{
    if(this.loaForm.get('contactEmail')?.disabled){
      return !this.loaForm.valid || (this.f1['generateType'].value == 3 && !this.selectedFile)
    }
    else{
      return !this.loaForm.valid || (this.f1['generateType'].value == 3 && !this.selectedFile) || !this.contactDetailFormGroup.valid
    }
  }

}
